import { ADMIN_PANEL_CLIENT_ID } from 'constants/auth';

export class UserPropertiesManagementApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getUserProperties({ userId }) {
    return this.#http.get(`api/users/${userId}/properties`, {
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
      paramsSerializer: { indexes: true },
    });
  }

  async editUserProperty({ userId, property }) {
    return this.#http.put(`api/users/${userId}/properties`, [property], {
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
    });
  }

  async deleteUserProperty({ userId, property }) {
    return this.#http.delete(`api/users/${userId}/properties`, {
      data: [property],
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
    });
  }
}
